if (window.tagEngineDataLayer.features?.raineAdsTracking) {
	const sendCustomPageview = () => {
		const pageFromPath = window.location.pathname.replace('/app', '').replaceAll('/', '');
		if (pageFromPath === 'today') {
			window.trackRaineEvent?.('custom_event', 'today_pageview');
			window.sendGenericEvents?.(true);
		}
	}

	if (typeof window.ketch === 'function') {
		window.ketch('on', 'consent', () => {
			sendCustomPageview();
		});
	} else {
		sendCustomPageview();
	}
	window.addEventListener('popstate', sendCustomPageview);
}
